<template>
    <div class="admin flexrow">
        <!-- 导航栏 -->
        <div class="admin-left flexcloum" :class="{isBarTrigger:trigger}">
            <!-- 登录用户信息 -->
            <img src="https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/logo/logo6.png" alt="userimg" class="userPage">
            <div class="userName">{{username}}</div>
            <!-- 切换功能菜单 -->
            <ul class="admin-table-ul">
                <!-- 首页信息汇总项 -->
                <!-- <li class="admin-table-li flexrow" @click="toPath('1')" :class="{Tabactive:tab==='1'}"><i
                        class="el-icon-s-home"></i><span class="li-title">首页汇总</span></li> -->
                <!-- 上传商品 -->
                <!-- <li class="admin-table-li flexrow" @click="toPath('2')" :class="{Tabactive:tab==='2'}"><i
                        class="el-icon-s-goods"></i><span class="li-title">商品上传</span></li> -->
                <!-- 上传博客 -->
                <li class="admin-table-li flexrow" @click="toPath('3')" :class="{Tabactive:tab==='3'}"><i
                        class="el-icon-s-management"></i><span class="li-title">文章编辑</span></li>
                <!-- <li class="admin-table-li flexrow" @click="toPath('4')" :class="{Tabactive:tab==='4'}"><i
                        class="el-icon-s-management"></i><span class="li-title">文章分类</span></li> -->
                <li class="admin-table-li flexrow" @click="toPath('4')" :class="{Tabactive:tab==='4'}"><i
                        class="el-icon-s-management"></i><span class="li-title">FAQ问题</span></li>
                <!-- <li class="admin-table-li flexrow" @click="toPath('5')" :class="{Tabactive:tab==='5'}"><i
                        class="el-icon-s-management"></i><span class="li-title">FAQ分类</span></li> -->
                <!-- 处理留言 -->
                <li class="admin-table-li flexrow" @click="toPath('5')" :class="{Tabactive:tab==='5'}"><i
                        class="el-icon-s-comment"></i><span class="li-title">客户留言</span></li>
                <!-- 修改banner -->
                <!-- <li class="admin-table-li flexrow" @click="toPath('5')" :class="{Tabactive:tab==='5'}"><i
                        class="el-icon-picture-outline-round"></i><span class="li-title">店铺海报</span></li> -->
                <!-- 商品标签 -->
                <!-- <li class="admin-table-li flexrow" @click="toPath('6')" :class="{Tabactive:tab==='6'}"><i
                    class="el-icon-s-check"></i><span class="li-title">商品标签</span></li>           -->
            </ul>
            <!-- 安全退出按钮 -->
            <div class="submit flexrow" @click='out'><i class="el-icon-s-fold"></i><span class="li-title">安全退出</span>
            </div>
            <!-- 折叠按钮 -->
            <!-- <div class="trigger-button" @click="buttonTrigger"><i class="iconfont icon-sanjiaoxing"
                    :class="{isTrigger:trigger}"></i></div> -->
        </div>
        <!-- 内容区域 -->
        <div class="admin-right">
            <!-- <AdminHome v-if='tab==="1"'></AdminHome>
            <AdminStore v-else-if='tab==="2"'></AdminStore> -->
            <AdminBlogSys v-if='tab==="3"'></AdminBlogSys>
            <ArticlClassify v-else-if='tab==="4"'></ArticlClassify>  
            <AdminMassage v-else-if='tab==="5"'></AdminMassage>
            <!-- <AdminBannerUp v-else-if='tab==="5"'></AdminBannerUp>
            <Commtrue v-else-if='tab==="6"'></Commtrue> -->
            <!-- <AdminDianp v-else-if='tab==="7"'></AdminDianp> -->
        </div>
    </div>
</template>
<script>
    // import AdminHome from '../../components/admin/adminhome'//引入信息汇总模块
    // import AdminStore from '../../components/admin/adminstore'//引入商品上传模块   
    import AdminBlogSys from '../../components/admin/adminblogsys'//引入博客模块
    import ArticlClassify from '../../components/admin/articlclassify'//引入文章分类   
    import AdminMassage from '../../components/admin/adminmassage'//引入留言模块   
    // import AdminBannerUp from '../../components/admin/adminbannerup'//引入海报模块 
    // import Commtrue from '../../components/admin/adminCommtrue'//引入商品分类模块
    // import AdminDianp from '../../components/admin/adiminDianp'//引入店铺模块     
    export default {
        name: 'Admin',
        components: {
            // AdminHome,
            // AdminStore,
            AdminBlogSys,
            ArticlClassify,
            AdminMassage,
            // AdminBannerUp,
            // Commtrue,
            // AdminDianp
        },
        mounted() { //页面初始化方法
            this.getToken()
        },
        data() {
            return {
                //控制侧边栏展开缩进
                trigger: false,
                //登录用户的名字
                username: '',
                //控制菜单栏选择的样式
                tab: '3'
            }
        },
        methods: {
            //控制侧边栏展开缩进
            buttonTrigger() {
                this.trigger = !this.trigger
            },
            // 切换左侧菜单栏
            toPath(num) {
                this.tab = num
            },
            //判断是否存在token，不存在就返回login页面，存在就获取该token的信息
            getToken() {
                let myToken = window.sessionStorage.getItem('langjing-admin-token')
                myToken ?console.log('验证通过') : this.$router.push('/KQlogin')
            },
            out() {
                window.sessionStorage.removeItem('langjing-admin-token')
                window.location.href = '/lanjingshuzilogin'
            }
        }
    }
</script>
<style scoped>
    /* 引入字体图标 */
    /* @import url(../../font/iconfont/iconfont.css); */

    /* 页面的高度     */
    .admin {
        height: 100vh;
        overflow: hidden;
    }

    /* 左侧导航栏 */
    .admin-left {
        width: 300px;
        height: 100%;
        padding: 15px;
        background-color: #000;
        position: relative;
        transition: all 0.5s;
        justify-content: flex-start;
    }

    /* 导航栏上面的折叠按钮 */
    .trigger-button {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        height: 55px;
        width: 40px;
        padding-right: 5px;
        border-radius: 10px;
        background-color: #76C200;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translate(50%, -50%);
        transition: all 0.3s;
        cursor: pointer;
        z-index: 0;
    }

    /* 控制面板缩进 */
    .iconfont {
        transition: all 0.3s;
        color: #ffffff;
        transform: rotate(-180deg);
    }

    /* 箭头变化 */
    .isTrigger {
        transform: rotate(0deg);
    }

    /* 左侧面板宽度变化 */
    .isBarTrigger {
        padding-right: 0;
        padding-left: 0;
        width: 4%;
    }

    /* 左侧面板内部信息的变化 */
    .li-title {
        transition: all 0.3s;
    }

    .isBarTrigger .userPage {
        width: 50px;
        height: 50px;
    }

    .isBarTrigger .li-title {
        opacity: 0;
        display: none;
    }

    .isBarTrigger .admin-table-li i {
        font-size: 24px;
    }

    /* 左侧面板内用户头像 */
    .userPage {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        margin-bottom: 10px;
        transition: all 0.5s;
    }

    /* 左侧面板内的用户名 */
    .userName {
        color: #ffffff;
        font-size: 20px;
        margin-bottom: 20px;
    }

    /* 左侧面板的菜单切换区域 */
    .admin-table-ul {
        width: 100%;
        z-index: 5;
    }

    .admin-table-li {
        height: 58px;
        cursor: pointer;
    }

    .admin-table-ul i {
        margin-right: 10px;
        transition: all 0.3s;
    }

    .admin-table-ul i,
    .admin-table-ul .li-title {
        font-size: 16px;
        color: #ffffff;
        transition: all 0.5s;
    }

    /* 左侧面板菜单选择样式 */
    .admin-table-li:hover {
        background-color: rgba(0, 0, 0, .3);
    }

    /* 安全退出按钮 */
    .submit {
        position: absolute;
        bottom: 2%;
        background-color: #c43a30;
        height: 50px;
        width: 100%;
        cursor: pointer;
        transition: all 0.5s;
    }

    .submit:hover {
        background-color: #ffb199;
    }

    .submit i {
        margin-right: 10px;
    }

    .submit i,
    .submit span {
        font-size: 16px;
        color: #ffffff;
    }

    /* 左侧面板菜单项选中效果 */
    .Tabactive {
        background-color: rgba(0, 0, 0, .3);
    }


    /* 右侧内容区域样式 */
    .admin-right {
        height: 100%;
        width: 100%;
        padding: 2%;
        /* flex-grow: 1; */
        background-color: #f9f9f9;
    }
</style>


// WEBPACK FOOTER //
// src/pages/adime/admin.vue